"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzBreadcrumbs__Wrapper",
  componentId: "sc-5ocxch-0"
})(["\n  display: flex;\n  align-items: flex-end;\n\n  & a{\n    text-decoration: none;\n  }\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Item = _styledComponents.default.div.withConfig({
  displayName: "OzBreadcrumbs__Item",
  componentId: "sc-5ocxch-1"
})(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-weight: bold;\n\n  ", "\n\n"], _consts.CHETWODEBLUE, function (props) {
  return !props.first ? "\n    &:before{\n      content: \"/\";\n      display: inline-grid;\n      padding: 0px 5px;\n    }\n  " : "\n    margin-right: 3px;\n  ";
});

var Icon = _styledComponents.default.div.withConfig({
  displayName: "OzBreadcrumbs__Icon",
  componentId: "sc-5ocxch-2"
})(["\n  display: inline-grid;\n  margin-right: 5px;\n"]);

var Text = _styledComponents.default.div.withConfig({
  displayName: "OzBreadcrumbs__Text",
  componentId: "sc-5ocxch-3"
})(["\n  font-size: ", "px;\n  line-height: ", "px;\n  display: inline-grid;\n"], function (props) {
  return props.first ? 20 : 12;
}, function (props) {
  return props.first ? 25 : 15;
});

var OzBreadcrumbs = function OzBreadcrumbs(_ref) {
  var values = _ref.values;
  return __jsx(Wrapper, null, values.map(function (item, i) {
    return __jsx(_react.default.Fragment, {
      key: i
    }, item.link ? __jsx(_react.default.Fragment, null) : __jsx(Item, {
      first: i === 0
    }, item.icon ? __jsx(Icon, null, __jsx(_OzIcon.default, {
      name: item.icon,
      size: i === 0 ? "25px" : "15px",
      color: _consts.CHETWODEBLUE
    })) : null, __jsx(Text, {
      first: i === 0
    }, item.name)));
  }));
};

var _default = OzBreadcrumbs;
exports.default = _default;